import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/customer'

import component from 'components/Customers/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => {
  const obj = {
    customer: state.customer,
    routes: state.routes,
    initialValues: Object.assign({}, { routes: [], contacts: [] }, state.customer)
  }

  obj.initialValues.routes = obj.initialValues.routes.filter(o => o && o.day_of_week && o.id)
  obj.initialValues.routes.push({ day_of_week: undefined, id: undefined })

  obj.initialValues.contacts = obj.initialValues.contacts.filter(o => o && (o.name || o.phone_number || o.email || o.title))
  obj.initialValues.contacts.push({ title: undefined, name: undefined, phone_number: undefined, email: undefined })
  return obj
}

const form = reduxForm({
  form: 'edit-customer',
  fields: [
    'id', 'name', 'notes', 'cc_orders',
    'routes[].day_of_week', 'routes[].id',
    'contacts[].title', 'contacts[].name', 'contacts[].phone_number', 'contacts[].email',
    'address', 'city', 'state', 'postcode'
  ],
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name for the customer.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Customers/containers/EditCustomerContainer.js